import { ErrorsType } from '@src/types/errors';

import { LoadersType } from '@modules/builders';

import { asyncActions } from './actions';

export type SellStateType = {
  loaders: LoadersType<typeof asyncActions>;
  errors: ErrorsType;
};

export const initialState: SellStateType = {
  loaders: {},
  errors: {},
};

export default initialState;
